// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".meta{display:none;font-family:Fira Sans Condensed, Rubik, Helvetica, Arial Narrow, Arial, sans-serif;font-size:0.875rem}.meta .category{font-weight:700;--tw-text-opacity:1;color:rgb(205 23 25 / var(--tw-text-opacity))}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
